import classNames from 'classnames'
import React from 'react'

import useCurrentCompanyOrFail from '../../../../../../hooks/useCurrentCompanyOrFail'
import useMinWidth from '../../../../../../hooks/useMinWidth'
import CompanyCompassCopyLinkButton from '../../../../../compass/CompanyCompassCopyLinkButton'
import CompanyCompassLinkInput from '../../../../../compass/CompanyCompassLinkInput'
import CompassGlobalLinkTooltip from '../../../../../compass/CompassGlobalLinkTooltip'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>

const CompanyCompassLink: React.FC<Props> = ({ className, ...props }) => {
  const currentCompany = useCurrentCompanyOrFail()
  const isMinWidthMd = useMinWidth('md')

  return (
    <section
      className={classNames(
        'd-flex flex-column flex-md-row justify-content-md-end gap-2 gap-md-3 flex-grow-1',
        className,
      )}
      {...props}
    >
      <div
        className="d-flex position-relative"
        style={{
          top: isMinWidthMd ? '8px' : '0',
        }}
      >
        <CompassGlobalLinkTooltip />

        <h4
          className="d-inline-block fw-bolder text-black mb-0 flex-grow-1"
          style={{
            fontSize: '14px',
            marginLeft: '5px',
          }}
        >
          {currentCompany.presentationName}'s global link:
        </h4>
      </div>

      <div className="d-flex flex-row flex-md-wrap align-items-center w-100 w-md-auto">
        <CompanyCompassLinkInput
          style={{ width: isMinWidthMd ? '300px' : undefined }}
        />

        <CompanyCompassCopyLinkButton />
      </div>
    </section>
  )
}

export default CompanyCompassLink
